import { ACTION, ACTION_SUBJECT, ACTION_SUBJECT_ID, EVENT_TYPE } from '@atlaskit/editor-common/analytics';
import { getActiveColorNew } from '../pm-plugins/utils/color';
import { removeColor } from './remove-color';
import { toggleColor } from './toggle-color';

/**
 * Helper to create an analytics payload
 * @param newColor  - Color to be change in hex code
 * @param previousColor - Active color in hex code
 * @param palette - Current palette of colors
 * @returns Higher order command with analytics logic inside.
 */
function createColorAnalyticsPayload(newColor, previousColor, palette, inputMethod) {
  var newColorFromPalette = palette.find(function (_ref) {
    var value = _ref.value;
    return value === newColor;
  });
  var previousColorFromPalette = palette.find(function (_ref2) {
    var value = _ref2.value;
    return value === previousColor;
  });
  var newColorLabel = newColorFromPalette ? newColorFromPalette.label : newColor;
  var previousColorLabel = previousColorFromPalette ? previousColorFromPalette.label : previousColor || '';
  return {
    action: ACTION.FORMATTED,
    actionSubject: ACTION_SUBJECT.TEXT,
    actionSubjectId: ACTION_SUBJECT_ID.FORMAT_COLOR,
    eventType: EVENT_TYPE.TRACK,
    attributes: {
      newColor: newColorLabel.toLowerCase(),
      previousColor: previousColorLabel.toLowerCase(),
      inputMethod: inputMethod
    }
  };
}
export var changeColor = function changeColor(color, api, inputMethod) {
  return function (_ref3) {
    var _api$analytics2;
    var tr = _ref3.tr;
    var textColor = tr.doc.type.schema.marks.textColor;
    var pluginState = api === null || api === void 0 ? void 0 : api.textColor.sharedState.currentState();
    if (!textColor || !pluginState) {
      return tr;
    }
    var activeColor = getActiveColorNew(tr);
    var colorAnalyticsPayload = createColorAnalyticsPayload(color, activeColor, pluginState.palette, inputMethod);
    if (pluginState.disabled) {
      return tr;
    }
    if (color === pluginState.defaultColor) {
      var _api$analytics;
      api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.attachAnalyticsEvent(colorAnalyticsPayload)(tr);
      removeColor({
        tr: tr
      });
      return tr;
    }
    api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 || _api$analytics2.actions.attachAnalyticsEvent(colorAnalyticsPayload)(tr);
    toggleColor(color)({
      tr: tr
    });
    return tr;
  };
};